/*
 * Left-side navigation collapse/expand. When BrandedTheme.nav_placement is
 * "side", v5/common/navbar/sidebar.html renders a vertical rail with a
 * .nav-shrink-btn that toggles an icon-only collapsed state. The collapsed
 * state is remembered in localStorage (client-side only — no stored user
 * preference) so it survives navigation within the same browser.
 */
(function (c2, $) {
  'use strict';

  var STORAGE_KEY = 'c2.sidebar.collapsed';

  function isCollapsed() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function store(collapsed) {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch (e) {
      /* ignore (private mode / disabled storage) */
    }
  }

  function apply(nav, collapsed) {
    nav.classList.toggle('collapsed', collapsed);
    var btn = nav.querySelector('.nav-shrink-btn');
    if (btn) {
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }
  }

  function init() {
    var nav = document.getElementById('main-nav');
    if (!nav || !nav.classList.contains('side_navbar')) return;

    // The nav menus are shared with the top navbar (where they open downward).
    // In the sidebar they should fly out to the right of their anchor, so add
    // Bootstrap's `dropend` modifier to every dropdown parent in the rail.
    nav.querySelectorAll('.nav-item.dropdown').forEach(function (li) {
      li.classList.add('dropend');

      // Sidebar navigation scrolls when the nav rail is taller than the
      // viewport-bound shell, caused by tall banner images.
      // Bootstrap's default Popper strategy clips fly-outs meant to escape it.
      // Pre-creating the Dropdown instance here with strategy 'fixed' makes
      // the menu position itself against the viewport instead, so the click
      // handler reuses this instance rather than one with the clipped default config.
      var toggle = li.querySelector(':scope > .dropdown-toggle');
      if (toggle && window.bootstrap && bootstrap.Dropdown) {
        bootstrap.Dropdown.getOrCreateInstance(toggle, {
          boundary: 'viewport',
          popperConfig: function (defaultBsPopperConfig) {
            return Object.assign({}, defaultBsPopperConfig, { strategy: 'fixed' });
          },
        });
      }
    });

    apply(nav, isCollapsed());

    var btn = nav.querySelector('.nav-shrink-btn');
    if (btn && !btn.dataset.c2SidebarBound) {
      btn.dataset.c2SidebarBound = '1';
      btn.addEventListener('click', function () {
        var collapsed = !nav.classList.contains('collapsed');
        apply(nav, collapsed);
        store(collapsed);
      });
    }
  }

  c2.sidebar = { init: init };

  $(function () {
    init();
  });
})(window.c2 = window.c2 || {}, window.jQuery);
